import React from "react";
import { Skeleton } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";

const ViewGstr1Report = ({ isData, isLoading }) => {
  const { isUser } = useAuth();
  return (
    <>
      <div className="table-responsive rtable">
        <table className="table table-sm table-bordered text-center">
          <tbody>
            <tr>
              <td className="fw-600">
                GSTR1 REPORT - {isData?.reportInfo?.reportType}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex rtable">
          <div className="w-100 text-center">
            <table className="table table-sm table-bordered">
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      isData?.reportInfo?.store?.title || ""
                    )}
                  </td>
                  <td>From Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.fromdate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.fromdate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                  <td>To Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.todate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.todate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <table className="table table-sm table-bordered mb-3 rtable">
          <tbody>
            <tr>
              <td className="text-center">Invoice No</td>
              <td className="text-center">Invoice Date</td>
              <td className="text-center">Mode</td>
              <td className="text-center">Customer Name</td>
              <td className="text-center">State</td>
              <td className="text-center">State Code</td>
              <td className="text-center">GSTIN</td>
              {isData.reportMode === "SEPARATED" && (
                <td className="text-center">Product Title</td>
              )}
              <td className="text-center">Base Price</td>
              <td className="text-center">GST %</td>
              <td className="text-center">CGST Amount</td>
              <td className="text-center">SGST Amount</td>
              <td className="text-center">IGST Amount</td>
              <td className="text-center">Total Tax</td>
              <td className="text-center">Total Amount</td>
            </tr>
          </tbody>
          <tbody>
            {isLoading ? (
              [...Array(15)].map((_, index) => (
                <tr key={index}>
                  {[...Array(14)].map((__, i) => (
                    <td key={i} className="text-center">
                      <Skeleton variant="text" width={i === 0 ? 300 : 200} />
                    </td>
                  ))}
                </tr>
              ))
            ) : Array.isArray(isData?.reportData) &&
              isData?.reportData?.length > 0 ? (
              <>
                {isData?.reportData?.map((item, index) => (
                  <tr key={item.id || index}>
                    <td className="text-center">{item?.saleno}</td>
                    <td className="text-center">
                      {
                        DateConverter.ISOToDisplayFormat(
                          DateConverter.convertToTimeZone(item?.saledate),
                        ).date
                      }
                    </td>
                    <td className="text-center">{item?.saletype}</td>
                    <td className="text-center">{item?.customername}</td>
                    <td className="text-center">{item?.state}</td>
                    <td className="text-center">{item?.statecode}</td>
                    <td className="text-center">{item?.gstnumber}</td>
                    {isData.reportMode === "SEPARATED" && (
                      <td className="text-center">{item?.title}</td>
                    )}
                    <td className="text-center">
                      ₹
                      {CurrencyConverter.toCurrency(
                        item?.lineTotalBasePrice || 0,
                        "INR",
                      )}
                    </td>
                    <td className="text-center">{item?.taxpercentage} %</td>
                    <td className="text-center">
                      ₹
                      {CurrencyConverter.toCurrency(
                        item?.lineTotalCgstAmount || 0,
                        "INR",
                      )}
                    </td>
                    <td className="text-center">
                      ₹
                      {CurrencyConverter.toCurrency(
                        item?.lineTotalSgstAmount || 0,
                        "INR",
                      )}
                    </td>
                    <td className="text-center">
                      ₹
                      {CurrencyConverter.toCurrency(
                        item?.lineTotalIgstAmount || 0,
                        "INR",
                      )}
                    </td>
                    <td className="text-center">
                      ₹
                      {CurrencyConverter.toCurrency(
                        item?.lineTotalTaxAmount || 0,
                        "INR",
                      )}
                    </td>
                    <td className="text-center">
                      ₹
                      {CurrencyConverter.toCurrency(
                        item?.lineTotalSoldPrice || 0,
                        "INR",
                      )}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={7} className="text-end">
                    Total
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      isData.reportSummary?.totalBasePrice || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center"></td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      isData.reportSummary?.totalCgstAmount || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      isData.reportSummary?.totalSgstAmount || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      isData.reportSummary?.totalIgstAmount || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      isData.reportSummary?.totalTaxAmount || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      isData.reportSummary?.totalSoldPrice || 0,
                      "INR",
                    )}
                  </td>
                </tr>
              </>
            ) : (
              <tr>
                <td colSpan="15" className="text-center p-2">
                  <small className="text-muted">
                    No sale found in the store. add some customers to get
                    started.
                  </small>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* {isData.reportInfo?.reportType === 'CONSOLIDATED' || isData.reportInfo?.reportType === 'DETAILED' && ( */}
        <>
          <table className="table table-sm table-bordered mb-0 rtable w-30 text-center">
            <thead>
              <tr>
                <td className="w-25">Tax %</td>
                <td>Tax Amount</td>
                <td>SGST Amount</td>
                <td>CGST Amount</td>
                <td>IGST Amount</td>
              </tr>
            </thead>
            <tbody>
              {isData?.taxSummary?.slice(0, -1).map((item, index) => (
                <tr key={index}>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `${item.taxpercentage}%`
                    )}
                  </td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(item?.totalTaxAmount || 0),
                        "INR",
                      )}`
                    )}
                  </td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(item?.totalSgstAmount || 0),
                        "INR",
                      )}`
                    )}
                  </td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(item?.totalCgstAmount || 0),
                        "INR",
                      )}`
                    )}
                  </td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(item?.totalIgstAmount || 0),
                        "INR",
                      )}`
                    )}
                  </td>
                </tr>
              ))}
              {!isLoading && isData?.taxSummary?.length > 0 && (
                <tr className="font-bold border-t bg-gray-100">
                  <td>Total</td>
                  <td>
                    ₹
                    {CurrencyConverter.toCurrency(
                      isData.taxSummary[isData.taxSummary.length - 1]
                        ?.taxTotal || 0,
                      "INR",
                    )}
                  </td>
                  <td>
                    ₹
                    {CurrencyConverter.toCurrency(
                      isData.taxSummary[isData.taxSummary.length - 1]
                        ?.sgstTotal || 0,
                      "INR",
                    )}
                  </td>
                  <td>
                    ₹
                    {CurrencyConverter.toCurrency(
                      isData.taxSummary[isData.taxSummary.length - 1]
                        ?.cgstTotal || 0,
                      "INR",
                    )}
                  </td>
                  <td>
                    ₹
                    {CurrencyConverter.toCurrency(
                      isData.taxSummary[isData.taxSummary.length - 1]
                        ?.igstTotal || 0,
                      "INR",
                    )}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </>
        {/* )} */}
      </div>
    </>
  );
};

export default ViewGstr1Report;
